import React from 'react';
import { IStyledHighlightProps, StyledHighlight } from '../../../../ui';

interface IStyledFlightDetailHighlightProps
	extends Partial<IStyledHighlightProps> {}

export const StyledFlightDetailHighlight = (
	props: IStyledFlightDetailHighlightProps,
) => <StyledHighlight {...(props as IStyledHighlightProps)} />;

StyledFlightDetailHighlight.defaultProps = {
	fullyClickable: false,
	elevated: true,
	orientation: ['horizontal', { tablet: 'vertical' }],
};
